import { keyframes } from '@vanilla-extract/css';
import { style } from '../layer.css.ts';
import { hairline } from '../theme-v2/hairline.ts';
import { themeV2 } from '../theme-v2/vars.ts';

const shimmer = keyframes({
  to: {
    backgroundPosition: '-200% 0',
  },
});

export const skeletonV2 = style({
  overflow: 'hidden',
  backgroundColor: themeV2.color.bg.surface.default,
  backgroundImage: `linear-gradient(90deg, ${themeV2.color.bg.surface.default} 0%, ${themeV2.color.bg.surface.secondary} 40%, ${themeV2.color.bg.surface.default} 80%)`,
  backgroundSize: '200% 100%',
  backgroundPosition: '200% 0',
  boxShadow: hairline(themeV2.color.border.subtle),
  animation: `${shimmer} 1.6s ease-in-out infinite`,
});
